import { render } from "./Settings_Component.vue?vue&type=template&id=4af7036e&scoped=true"
import script from "./Settings_Component.vue?vue&type=script&lang=js"
export * from "./Settings_Component.vue?vue&type=script&lang=js"

import "./Settings_Component.vue?vue&type=style&index=0&id=4af7036e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af7036e"]])

export default __exports__